<template>
  <div v-if="voteQuestions.length" class="vote-answer">
    <div style="margin-bottom: 12px" class="flex justify-between">
      <span>投票结果</span>
      <el-button type="text" @click="onOpenSearch">
        <span v-if="!isFilter">筛选</span>
        <template v-else-if="voteQuestions.length===1">
          <template v-if="answerValues.length > 10">
           <span class="text-theme-black-450"> {{answerValues.slice(0,10)}}...</span>
          </template>
          <span class="text-theme-black-450" v-else>{{ answerValues }}</span>
        </template>
        <span v-else>以下为筛选后的数据</span>
        <span><i class="el-icon-arrow-right" :class="{'text-theme-black-450':isFilter}"></i></span>
      </el-button>
    </div>
    <div v-for="item in voteQuestions" :key="item.q_id">
      <vote-question :question="item" />
    </div>
  </div>
</template>

<script>
import { busGetters, createQuestionFactory } from 'dygc'
import VoteQuestion from '@/vote/VoteQuestion.vue'
import { createPopup } from '@/assets/js/factory'
import SearchVotePopup from '@/vote/SearchVotePopup.vue'

export default {
  name: 'VoteAnswer',
  components: { VoteQuestion },
  computed: {
    ...busGetters(['voteQuestions']),
    isFilter() {
      return this.voteQuestions.some(item => item.issue.hasVoteFilter())
    },
    answerValues() {
      return this.voteQuestions.reduce((res, item) => {
        res += item.issue.getVoteAnswerValueText()
        return res
      }, '')
    }
  },
  methods: {
    onOpenSearch() {
      const list = this.voteQuestions.map((item, index) => {
        const q = createQuestionFactory(item)
        q.issue.voteAnswer = item.issue.voteAnswer
        q.num = index + 1
        return q
      })
      const vm = createPopup(SearchVotePopup, {
        list: list
      })

      vm.$on('confirm', () => {
        this.voteQuestions.forEach((item, index) => {
          item.issue.voteAnswer = list[index].issue.voteAnswer
        })
        vm.$emit('close')
      })
    }
  }
}
</script>

<style lang="scss">

</style>